export const DISPLAY_SCENE = 'DISPLAY_SCENE';
export default {
  DISPLAY_SCENE
};
